<template>
<div>
  <b-modal v-bind:id="modId" v-bind:title="this.$i18n.t('issue.issue')" hide-footer>
    <p class="my-4">{{ $i18n.t("issue.complete") }}</p>
    <b-button variant="primary" block @click='issueContinue'>{{ $i18n.t("issue.continue") }}</b-button>
    <b-button variant="primary" block @click='download'>{{ $i18n.t("issue.download") }}</b-button>
  </b-modal>
</div>
</template>
<script>
import confirmModal from './ConfirmModal'
export default {
  components: {
    confirmModal
  },
  name: 'Modal',
  props: ['modId', 'titleMsg', 'msg', 'buttonMsg'],
  methods: {
    issueContinue: function () {
      this.$emit('issueContinue')
    },
    download: function () {
      this.$emit('download')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IssueModal.vue